import { Mouvement } from '@mairistem/comptabilite';
import { getErrorMessage } from '@mairistem/finances-utils';
import MouvementActionType from '../../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import BaseLiquidationAction from '../../../pieces/BaseLiquidationAction';
import ActionResultType from '../../../../interfaces/pieces/ActionResultType';
import TreeviewActionResult from '../../../../interfaces/pieces/TreeviewActionResult';
import type { BaseLiquidationOptions } from '../../../../interfaces/pieces/mouvements/liquidation/BaseLiquidationOptions';
import { supprimerMouvement } from '../../../../services/piecesComptables/mouvements/mouvements';

class MouvementSupprimerAction extends BaseLiquidationAction<Mouvement, MouvementActionType> {
  constructor(options: BaseLiquidationOptions = null) {
    super(options);
    this.label = 'Supprimer';
    this.type = MouvementActionType.DELETE;
  }

  execute = (mouvement: Mouvement): TreeviewActionResult<Mouvement> => ({
    type: ActionResultType.MODAL,
    result: Promise.resolve(mouvement),
    extraProps: {
      deleteModal: {
        visible: true,
        typeAction: MouvementActionType.DELETE,
      },
    },
  });

  executeAction = (mouvement: Mouvement): TreeviewActionResult<Mouvement> => ({
    result: new Promise((resolve, reject) => {
      supprimerMouvement(mouvement.identifiant as number).then(() => {
        resolve(mouvement);
      }).catch((e) => {
        reject(Error(getErrorMessage(e, 'Erreur lors de la suppression du mouvement')));
      });
    }),
    type: ActionResultType.DELETE,
  });
}

export default MouvementSupprimerAction;
